var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.95 34.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.46,23.76c.35-2.59,4.15-2.72,4.41.22s-.18,6.11-.01,9.02c-.15.8-.66,1.47-1.43,1.73-10.45.33-20.98.04-31.47.14-.87-.03-1.84-.9-1.96-1.76l.02-9.67c.46-1.56,2.35-2.23,3.61-1.1.12.11.65.88.65.96v7.17h26.18v-6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,7.57v16.53c0,.4-.38,1.17-.69,1.46-1.06.98-2.72.78-3.42-.5-.06-.11-.29-.55-.29-.61V7.57c-.4.01-.54.49-.78.74-.75.75-1.56,1.45-2.32,2.2s-1.88,2.32-2.98,2.54c-1.97.41-3.37-1.83-2.21-3.45L16.01.51c.84-.68,1.99-.68,2.83,0l8.97,8.97c1.71,2.24-1.17,4.83-3.22,2.99l-4.96-4.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.427e15cbf248a4f58af5d04b42466b9d.svg";
export { ForwardRef as ReactComponent };